<template>
  <div>
    <section class="material-half-bg">
      <div class="cover"></div>
    </section>
    <section class="login-content">
      <div class="my-4 text-white text-center">
        <h2>ระบบบริการไอที</h2>
        <h2>IT Service System</h2>
        <router-link to="/notify" class="text-white">
          - แจ้งบริการไอที -
        </router-link>
      </div>
      <div class="login-box">
        <form @submit.prevent="login" class="login-form">
          <h3 class="login-head">
            <i class="fa fa-lg fa-fw fa-user"></i>เข้าสู่ระบบ
          </h3>
          <div class="form-group">
            <label class="control-label">EMAIL</label>
            <input
              v-model="data.email"
              class="form-control"
              type="email"
              placeholder="Email"
              autofocus
            />
          </div>
          <div class="form-group">
            <label class="control-label">PASSWORD</label>
            <input
              v-model="data.password"
              class="form-control"
              type="password"
              placeholder="Password"
            />
          </div>
          <div class="form-group"></div>
          <div class="form-group btn-container">
            <button class="btn btn-primary btn-block">
              <i class="fas fa-sign-in-alt fa-fw"></i> เข้าสู่ระบบ
            </button>
          </div>
        </form>
      </div>
      <div class="text-center">
        <p class="mt-4 mb-2">
          © 2022 ระบบไอทีภาระงาน IT Service System | โรงพยาบาลวานรนิวาส
          จังหวัดสกลนคร
        </p>
        <p class="mb-4">พัฒนาโดย นายบัญชาชัย แพงพิมพ์โล้</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  methods: {
    login() {
      this.$store
        .dispatch("login", this.data)
        .then(() => {
          this.$router.push({ name: "Dashboard" });
          this.$swal.fire({
            title: "เข้าสู่ระบบสำเร็จ",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((err) => {
          this.showError();
          console.log(err);
        });
    },
  },
  created() {
    // console.log(process.env);
  },
};
</script>

<style>
</style>